import { Icon, type Props } from "./StemsIcon.Parts";

export const StemsIcon = ({ small, ...props }: Props) => (
  <Icon
    viewBox="0 0 20 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    $small={small}
    {...props}
  >
    <rect y="11.25" width="8.75" height="2.5" rx="0.2" fill="currentColor" />
    <rect
      x="11.25"
      y="11.25"
      width="3.75"
      height="2.5"
      rx="0.2"
      fill="currentColor"
    />
    <rect x="10" y="15" width="10" height="2.5" rx="0.2" fill="currentColor" />
    <rect x="2.5" width="13.75" height="2.5" rx="0.2" fill="currentColor" />
    <rect
      x="3.75"
      y="7.5"
      width="13.75"
      height="2.5"
      rx="0.2"
      fill="currentColor"
    />
    <rect
      x="7.5"
      y="3.75"
      width="6.25"
      height="2.5"
      rx="0.2"
      fill="currentColor"
    />
    <rect
      x="16.25"
      y="3.75"
      width="2.5"
      height="2.5"
      rx="0.2"
      fill="currentColor"
    />
  </Icon>
);
